export default "<button title=\"Enable\" class=\"btn btn-success\" (click)=\"enable()\">{{'BUTTONS.ENABLE' | translate}}</button>";